/** @see common/enums/mod/ShareTypeEnum */
//Типы процессинга
export const ShareTypeProcessingEnum = {
    window: 'window',
    clipboard: 'clipboard',
}

//возращаемый объект пока так, через спрэд его использовать можно
//если нужно строже то можно класс сделать в будущем
let baseReturnObject =  {
    url: null,
    typeProcessing: null
};

//Тут тоже быстро накидал, потом если что можно заменить на базовый класс
//с extend ами, но так как кода немного, решил скопипастить
export const ShareTypeEnum = {
    link: {
        callback: function (setups) {
            return {
                ...baseReturnObject,
                url: setups.location,
                typeProcessing: ShareTypeProcessingEnum.clipboard,
            }
        }
    },
    telegram: {
        callback: function (setups) {
            let url = "https://telegram.me/share/url?"
                + `url=${setups.location}`
                + `&text=${setups.description ? setups.description : setups.title}`
            ;
            return {
                ...baseReturnObject,
                url: url,
                typeProcessing: ShareTypeProcessingEnum.window,
            }
        }
    },
    vk: {
        callback: function (setups) {
            let url = `https://vk.com/share.php?url=${setups.location}`;
            return {
               ...baseReturnObject,
                url: url,
                typeProcessing: ShareTypeProcessingEnum.window,
            }
        }
    },
    ok: {
        callback: function (setups) {
            let url = "https://connect.ok.ru/offer?"
                + `url=${setups.location}`
                + `&title=${setups.title}`
                + `&description=${setups.description}`
                + `&imageUrl=${setups.imageUrl}`;

           return {
               ...baseReturnObject,
                url: url,
                typeProcessing: ShareTypeProcessingEnum.window,
            }
        }
    },
};